import React from "react";
import { useDispatch, useSelector } from "react-redux";
import TheHeader from "./comm/TheHeader";
import {
  CCardBody,
  CContainer,
} from "@coreui/react";
import queryString from "query-string";
import TheNav from "./comm/TheNav";
import TheFooter from "./comm/TheFooter";
import ApiHelper from "src/utils/api/api_helper";
import Swal from "sweetalert";
import { setReqTaskInfo } from "../../modules/insert";
import { useHistory, useLocation } from "react-router-dom";
import { Basic, BrInfo, Email, Addr, Bank, Recr, Fax , EduLevel} from '../../reusable/index';

const InsertPage = () => {
  const { main, insert } = useSelector((state) => state);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const corpNm = useLocation().pathname.split('/')[1];
  const pathParam = Number(useLocation().pathname.split('/')[2]);
  const [initData, setInitData] = React.useState({
    buBrList: [],
    brList: [],
    bankList: [],
    emalDmnList: [],
    inputCpnt: [],
    eduLevelList: []
  });
  const query = queryString.parse(location.search);
  const param = { 
    corpNo: insert.isFirst ? query.corpNo : main.corpNo,
    taskNo: insert.isFirst ? query.taskNo : main.taskNo,
    reqNo: insert.isFirst ? query.reqNo : insert.reqNo
  };
  // 주민번호 확인 팝업
	const [isCheckJumin, setIsCheckJumin] = React.useState(false);

  const handleInputChange = async (e) => {
    const targetName = e.target.name;
    const regExpKor = /[ㄱ-ㅎㅏ-ㅣ가-힣]/g;
    const regKor = /[a-zA-Z0-9]/g;
    const regExpNum = /[^0-9]/g;
    const enable = /[@]/g;
    let changeData = {};
    let originVal = e.target.value;
    let val = "";

    switch (targetName) {
      case "resRegNoBack":
        setIsCheckJumin(false);
        val = originVal.replace(regExpNum, "");
        break;
      case "resRegNoFront":
        val = originVal.replace(regExpNum, "");
        break;
      case "actNo":
        val = originVal.replace(regExpNum, "");
        break;
      case "recrTel":
        val = originVal.replace(regExpNum, "");
        val = val.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,"$1-$2-$3").replace("--", "-");
        break;
      case "emalAddr":
        if (regExpKor.test(originVal))
          return Swal(
            "",
            "이메일주소는 영문과 숫자만 입력가능합니다.",
            "info"
          ).then(() => {
            document.getElementById("emalAddr").focus();
          });
        val = originVal.replace(regExpKor, "");
        if (enable.test(originVal))
          return Swal("", "이메일 `@` 앞부분만 입력해주세요.", "info").then(
            () => {
              document.getElementById("emalAddr").focus();
            }
          );
        val = originVal.replace(enable, "");
        break;
      case "emalDmn":
        if (regExpKor.test(originVal))
          return Swal(
            "",
            "이메일도메인은 영문과 숫자만 입력가능합니다.",
            "info"
          ).then(() => {
            document.getElementById("emalDmn").focus();
          });
        val = originVal.replace(regExpKor, "");
        break;
      case "recrEmpNo":
          if (regExpKor.test(originVal))
            return Swal(
              "",
              "도입자사번은 영문과 숫자만 입력가능합니다.",
              "info"
            ).then(() => {
              document.getElementById("recrEmpNo").focus();
            });
          val = originVal.replace(regExpKor, "");
          break;
      case "recrNm":
          if (main.corpNm == "megainfo" && regKor.test(originVal))
            return Swal(
              "",
              "증원자명은 한글만 입력가능합니다.", 
              "info"
              ).then(() => {
                document.getElementById("recrNm").focus();
            });
          val = originVal.replace(regKor, "");
          break;
      default:
        val = originVal;
        break;
    }

    changeData = { [e.target.name]: val };

    await dispatch(setReqTaskInfo(changeData, false));

    if (e.target.name === "buBrNo") {
      await dispatch(setReqTaskInfo({ brNo: "" }, false));
    }
  };

  // // 주민번호 유효성체크 추가
  // function juminCheck() {
  //   console.log("나오는건가");
  //   let jumin;
  //   jumin = insert.reqTaskInfo.resRegNoFront + insert.reqTaskInfo.resRegNoBack
  //   jumin = jumin.split(''); // 주민등록번호를 한자리씩 쪼개서 배열에 담기
    
  //   console.log(jumin);

  //   let ckarr = [2,3,4,5,6,7,8,9,2,3,4,5]; // 곱해줄 숫자 배열

  //   // 마지막자리 제외하고 각 자리에 ckarr값을 곱해줌
  //   for(let i=0; i<jumin.length-1; i++){
  //       jumin[i] = jumin[i] * ckarr[i];
  //   }
  //   let juminlast = jumin[jumin.length-1]; // 주민등록번호 마지막자리 따로 빼두기
  //   let frnJuminlast = (jumin[jumin.length-1] + 2); // 주민등록번호 마지막자리 외국인 확인용

  //   // 각 자리의 숫자를 모두 더하기
  //   let sum = 0;
  //   for(let i=0; i<jumin.length-1; i++){
  //       sum += jumin[i];
  //   }

  //   // 11로 나눈 나머지 값을 구하기
  //   sum = sum % 11;

  //   // 11에서 결과값 빼기
  //   sum = 11 - sum;
  //   // 마지막 결과가 두자리인 경우 다시 10으로 나눈 나머지 값을 구함
  //   if(sum > 9){
  //       sum = sum % 10;
  //   }

  //   console.log(sum);
  //   console.log(frnJuminlast);
  //   // 결과가 주민등록번호 마지막 자리와 일치하면 유효한 주민등록번호
  //   // 주민번호 일치
  //   if(sum == juminlast || sum == frnJuminlast){
  //     return 'same';
  //   }
  //   // 주민번호 불일치
  //   if((sum != juminlast || sum != frnJuminlast) && juminlast != undefined){ // 외국인까지 확인
  //     return 'notsame';
  //   }
  // }

   // 주민번호 유효성체크 추가
   function juminCheck() {
    let jumin;
    jumin = insert.reqTaskInfo.resRegNoFront + insert.reqTaskInfo.resRegNoBack
    // jumin = jumin.split(''); // 주민등록번호를 한자리씩 쪼개서 배열에 담기
    if( jumin.length !== 13 ) return 'notsame';

    let checkFrnNo = jumin.substr(6, 1); // 내국인 외국인 확인용 주민번호 7번째 자리
    
    // 검증값 합계
    var checkSum = 0;
    for(var i=0; i<12; i++) checkSum += ((jumin.substr(i,1)>>0)*((i%8)+2));
  
    // 검증
    var modCheckSum = checkSum%11;    // 검증값 합계의 11의 나머지수
    var rrnMatch = ((11-(modCheckSum))%10 == jumin.substr(12,1));    // 주민번호 검증
    var frnMatch = ((13-(modCheckSum))%10 == jumin.substr(12,1));    // 외국인번호 검증

    // 결과가 주민등록번호 마지막 자리와 일치하면 유효한 주민등록번호
    // 주민번호 일치
    if(rrnMatch || frnMatch){
      return 'same';
    } else {
      return 'notsame';
    }
  }

  const handleFillInInfo = (e, nextPage) => {
    let params = {};
    
    if (nextPage) {
      if (initData.inputCpnt.filter((item) => item.INPUT_COMP_CD === 'BR').length > 0 && insert.reqTaskInfo.brNo === "")
        return Swal("정보입력", "협회등록지점은 필수항목입니다", "error");
      if (initData.inputCpnt.filter((item) => item.INPUT_COMP_CD === 'BASIC').length > 0 && insert.reqTaskInfo.resRegNoBack.trim().length < 7)
        return Swal(
          "정보입력",
          "주민등록번호 뒤 7자리는 필수항목입니다",
          "error"
          );
      if(juminCheck() === 'notsame' )
        return Swal(
          "정보입력",
          "유효하지 않은 주민등록번호입니다.\n 다시 한 번 확인해주세요.",
          "error"
          );
      if (initData.inputCpnt.filter((item) => item.INPUT_COMP_CD === 'ADDR').length > 0 && insert.reqTaskInfo.addr.trim() === "")
        return Swal("정보입력", "주소는 필수항목입니다", "error");
      if (initData.inputCpnt.filter((item) => item.INPUT_COMP_CD === 'EMAIL').length > 0) {
        if (insert.reqTaskInfo.emalAddr.trim() === "")
          return Swal("정보입력", "이메일주소는 필수항목입니다", "error");
        if (insert.reqTaskInfo.emalDmn.trim() === "")
          return Swal("정보입력", "이메일도메인은 필수항목입니다", "error");
      }
      // 메가인포만 도입자사번 추가 및 필수조건 변경
      // if (initData.inputCpnt.filter((item) => item.INPUT_COMP_CD === 'RECR').length > 0 && main.corpNm === "megainfo") {
      //   if (insert.reqTaskInfo.recrEmpNo === "")
      //     return Swal("정보입력", "도입자사번은 필수항목입니다", "error");
      // }
      if (initData.inputCpnt.filter((item) => item.INPUT_COMP_CD === 'BANK').length > 0) {
        if (insert.reqTaskInfo.bankCd === "")
          return Swal("정보입력", "은행은 필수항목입니다", "error");
        if (insert.reqTaskInfo.actNo.trim() === "")
          return Swal("정보입력", "계좌번호는 필수항목입니다", "error");
      }
      if (initData.inputCpnt.filter((item) => item.INPUT_COMP_CD === 'RECR').length > 0 ) {
        if (insert.reqTaskInfo.recrNm.trim() === "" ){
          if (main.corpNm == "megainfo"){
            return Swal("정보입력", "증원자명은 필수항목입니다", "error");
          } else if ( main.corpNm == "metarich" ){
            return Swal("정보입력", "유치자명은 필수항목입니다", "error");
          } else if(!(main.corpNm == "LS-FC" || main.corpNm == "LS-EFA" )){
            return Swal("정보입력", "도입자명은 필수항목입니다", "error");
          }
        }
      }
      if (initData.inputCpnt.filter((item) => item.INPUT_COMP_CD === 'FAX').length > 0) {
        if (insert.reqTaskInfo.faxNo.trim() === "")
          return Swal("정보입력", "팩스번호는 필수항목입니다", "error");
      }
      if (initData.inputCpnt.filter((item) => item.INPUT_COMP_CD === 'EDU').length > 0) {
        if (insert.reqTaskInfo.eduLevel === "" || insert.reqTaskInfo.eduLevel === null )
          return Swal("정보입력", "학력은 필수항목입니다", "error");
      }

      // 주민번호 확인 팝업
      if (!isCheckJumin){
        setIsCheckJumin(true);
        return Swal(insert.reqTaskInfo.resRegNoFront + "-" + insert.reqTaskInfo.resRegNoBack, "입력하신 주민번호가 맞는지 한 번 더 확인해주세요.", "info");
      }
    }

    params = insert.reqTaskInfo;
    params.qlfcYn = main.qualificationYn;
    if(main.crerYn != undefined){
      params.crerYn = main.crerYn;
    }

    if(main.corpNo == '62' && main.hashValue == '#F'){
      params.fnrYn = '1'; //외국인 여부
    }    
    params.tempYn = nextPage;

    
    // 임시저장 여부
    params.tempYn = nextPage;   

    ApiHelper.request(
      ApiHelper.methods.post,
      "/cust/request/tempSaveStep3",
      params
    )
      .then(({ data }) => {
        if (data.status === "SUCCESS") {
          if (nextPage) {
            main.cntrYn === "0"
              ? history.push(`/${corpNm}/${pathParam + 2}`)
              : history.push(`/${corpNm}/${pathParam + 1}`);
          } else {
            return Swal("", "임시저장 되었습니다.", "success");
          }
        }else if(data.status === 'INVALID'){
          return Swal("주민등록번호", data.msg, "error");
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getInitData = async () => {
    const _initData = Object.assign({}, initData);
    const _data = {};

    await ApiHelper.request(ApiHelper.methods.get, "/code/commcd/CM105")
      .then(({ data }) => {
        if (data.status === "SUCCESS") {
          let result = data.data;
          _initData.bankList = result;
        }
      })
      .catch((err) => {
        console.error(err);
      });

    await ApiHelper.request(ApiHelper.methods.get, "/code/commcd/CM103")
      .then(({ data }) => {
        if (data.status === "SUCCESS") {
          let result = data.data;
          _initData.emalDmnList = result;
        }
      })
      .catch((err) => {
        console.error(err);
      });

    await ApiHelper.request(
      ApiHelper.methods.post,
      "/cust/request/buBrList",
      param
    )
      .then(({ data }) => {
        if (data.status === "SUCCESS") {
          let result = data.data;
          _initData.buBrList = result;
        }
      })
      .catch((err) => {
        console.error(err);
      });

    await ApiHelper.request(
      ApiHelper.methods.post,
      "/cust/request/getBrList",
      param
    )
      .then(({ data }) => {
        if (data.status === "SUCCESS") {
          let result = data.data;
          _initData.brList = result;
        }
      })
      .catch((err) => {
        console.error(err);
      });
    
      await ApiHelper.request(
        ApiHelper.methods.post,
        "/cust/request/getInputCpnts",
        param
      )
      .then(({ data }) => {
        if (data.status === "SUCCESS") {
          let result = data.data;
          _initData.inputCpnt = result;
        }
      })
      .catch((err) => {
        console.error(err);
      });

      await ApiHelper.request(ApiHelper.methods.get, "/code/commcd/CM107")
      .then(({ data }) => {
        if (data.status === "SUCCESS") {
          let result = data.data;
          _initData.eduLevelList = result;
        }
      })
      .catch((err) => {
        console.error(err);
      });
      
    await setInitData(_initData);

    if (insert.isFirst) {
      await ApiHelper.request(
        ApiHelper.methods.post,
        "/cust/request/reqTaskInfo",
        param
      )
        .then(({ data }) => {
          if (data.status === "SUCCESS") {
            let result = data.data[0];

            _data.reqNo = result.REQ_NO;
            _data.stCd = result.ST_CD;
            _data.buBrNo = result.GRP_BR_NO;
            _data.brNo = result.BR_NO;
            _data.name = result.NAME;
            _data.hphnNo = result.HPHN_NO;
            _data.resRegNoFront = result.RES_REG_NO_FRONT;
            _data.resRegNoBack = result.RES_REG_NO_BACK;
            _data.bdt = result.BDT;
            _data.emalAddr = result.EMAL_ADDR;
            _data.emalDmn = result.EMAL_DMN;
            _data.postNo = result.POST_NO;
            _data.addr = result.ADDR;
            _data.dtlAddr = result.DTL_ADDR;
            _data.sex = result.SEX;
            _data.bankCd = result.BANK_CD;
            _data.actNo = result.ACT_NO;
            _data.actNm = result.NAME;
            _data.crerYn = result.CRER_YN;
            _data.recrNm = result.RECR_NM;
            _data.recrEmpNo = result.RECR_EMP_NO;
            _data.recrOflv = result.RECR_OFLV;
            _data.recrTel = result.RECR_TEL;
            _data.faxNo = result.FAX_NO;
            _data.eduLevel = result.EDU_LEVEL;
            _data.fnrYn = result.FNR_YN;
          }
        })
        .catch((err) => {
          console.error(err);
        });

      await dispatch(setReqTaskInfo(_data, true));
    }
  };

  React.useEffect(async () => {
    await getInitData();

    window.history.pushState({}, null, '#init');
		window.history.pushState({}, null, `/${corpNm}/3`);
		window.history.pushState({}, null, `/${corpNm}/3`);
		window.onpopstate = function(e) {
			if( window.location.hash == "#init") {
				window.history.go(1);
			}
    }
  }, []);

  return (
    <>
      <TheHeader />
      <div className="c-main">
        <TheNav step={main.step} />
        <CContainer className="text-left">
          <h5>
            <b>
              {main.cntrYn !== "0" && "위촉계약서 및 "}보험사별 위촉서류
              작성을 위한 정보를 입력합니다.
            </b>
          </h5>
        </CContainer>
        <CCardBody className="bottom-card-body">
          { initData.inputCpnt.length > 0
            &&
            initData.inputCpnt.map((data) => {
              switch (data.INPUT_COMP_CD) {
                case 'BR':
                  return (
                    <BrInfo 
                      key={data.INPUT_COMP_CD}  
                      buBrList={initData.buBrList} 
                      brList={initData.brList} 
                      handleInputChange={handleInputChange}
                    >
                    </BrInfo>
                  )
                case 'BASIC':
                  return (
                    <Basic 
                      key={data.INPUT_COMP_CD}  
                      handleInputChange={handleInputChange}
                    >
                    </Basic>
                  )
                case 'ADDR':
                  return (
                    <Addr 
                      key={data.INPUT_COMP_CD}  
                      handleInputChange={handleInputChange}
                    >
                    </Addr>
                  )
                case 'EMAIL':
                  return (
                    <Email 
                      key={data.INPUT_COMP_CD}  
                      emalDmnList={initData.emalDmnList} 
                      handleInputChange={handleInputChange}
                    >
                    </Email>
                  )
                case 'BANK':
                  return (
                    <Bank 
                      key={data.INPUT_COMP_CD}    
                      bankList={initData.bankList}
                      handleInputChange={handleInputChange}
                    >
                    </Bank>
                  )
                case 'RECR':
                  return (
                    <Recr 
                      key={data.INPUT_COMP_CD}    
                      handleInputChange={handleInputChange}
                    >
                    </Recr>
                  )
                case 'FAX':
                  return (
                    <Fax 
                      key={data.INPUT_COMP_CD}    
                      handleInputChange={handleInputChange}
                    >
                    </Fax>
                  )
                  case 'EDU':
                    return (
                      <EduLevel
                        key={data.INPUT_COMP_CD}    
                        eduLevelList={initData.eduLevelList} 
                        handleInputChange={handleInputChange}
                      >
                      </EduLevel>
                    )
                default:
                  break;
              }
            })
          }
        </CCardBody>
      </div>
      <TheFooter
        step={main.step}
        cntrYn={main.cntrYn}
        handleFillInInfo={handleFillInInfo}
      />
    </>
  );
};

export default InsertPage;
